import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  typography: {
    fontSize: 20,
    useNextVariants: true,
  },
  article: {
    quantityWidth: 38,
  },
  header: {
    height: 76,
  },
  order: {
    buttons: {
      fontSize: 22,
    },
  },
  appbar: {
    buttons: {
      fontSize: 22,
    },
  },
});
